module.exports = __webpack_public_path__ + "img/what-are-coronaviruses-image-2.0e2580fa.png";